import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivityTypesLogicService } from './logic/activity-types/activity-types-logic.service';
import { ActivityTypesDaoService } from './dao/activity-types-dao.service';
import { ActivityTypesStorageDaoService } from './dao/activity-types-dao/activity-types-storage-dao.service';
import { ActivityTypesService } from './logic/activity-types.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: ActivityTypesService, useClass: ActivityTypesLogicService },
    {
      provide: ActivityTypesDaoService,
      useClass: ActivityTypesStorageDaoService
    }
  ]
})
export class ActivityTypesModule {}
